import {searchModel} from "../../Utilities/Search";


export const userSearchModel = (userId: string | number, fullName = "", email = "", organization = "", districtId = "", isActive = "", patronRole = "", patronSubType = "", approvalStatus = "0", showOnlyDelegates = "") => {
    return Object.assign({}, searchModel(userId.toString(), "email", false, "email"), {
        fullName,
        email,
        organization,
        districtId,
        isActive,
        patronRole,
        patronSubType,
        approvalStatus,
        showOnlyDelegates,
        ClearUserSearch: clearUserSearch,
    });
};

function clearUserSearch(this: Record<string, any>) {
    this.fullName = "";
    this.email = "";
    this.organization = "";
    this.districtId = "";
    this.isActive = "";
    this.patronRole = "";
    this.patronSubType = "";
    this.approvalStatus = "";
    this.showOnlyDelegates = "";
    this.ClearSearch(false);
}
